export { default } from './Minimalistic';
